import React from 'react';
import PropTypes from 'prop-types';

const IconMadeToOrder = ({
  width = 11,
  height = 16,
  color = '#424242',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_3_2130)">
      <path
        d="M10.8617 1.79692C10.2602 1.32609 9.59924 0.89337 8.8247 0.533353C7.30434 -0.166424 5.46928 -0.194503 3.27257 0.548897C3.02811 1.58041 1.78918 1.34816 1.17414 1.10778L1.05742 1.05864L1.05077 1.05593V1.05633L1.05048 1.05603L0.238596 1.23504C0.0771126 1.27064 -0.0273433 1.43961 0.00630309 1.60969L0.493796 4.07155C0.528583 4.24704 0.692823 4.36077 0.859439 4.32396L1.66486 4.14636L1.74442 4.02692C2.6619 2.73858 4.1565 2.6019 4.48099 4.35946L6.61554 3.88883C6.43182 2.91929 5.88654 1.56296 8.28608 1.66084C9.08779 1.70807 9.86727 1.88066 10.6289 2.15283C10.926 2.25101 11.1597 2.03058 10.8616 1.79672L10.8617 1.79692Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.70037 4.19185L4.56592 4.66278C5.04666 7.06176 5.40033 10.656 6.26516 12.8021C6.70589 13.8952 6.02421 14.9839 6.7229 15.9999L9.59178 15.3669L6.70037 4.19185Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3_2130">
        <rect width="11" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

IconMadeToOrder.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export default IconMadeToOrder;
